import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss']
})
export class FileComponent implements OnInit {
  @Input() imageSource = '/assets/image/bannerx.jpg';
  @Input() imagePreview: string | undefined = '/assets/image/bannerx.jpg';
  @Input() viewType = 'fill';

  constructor() { }

  ngOnInit(): void {
  }

}
